import axios from 'axios'

export default {
  name: 'helpers',
  doPost (users, call, payload, state) {
    return new Promise((resolve) => {
      axios.post(call, payload, state.graphConfig).then(response => {
        response.data.responses.forEach(userList => {
          users.push(userList.body.value)
        })
        users = users.flat()
        resolve(users)
      })
    })
  },
  buildBatchPayload (id, emails, payload) {
    // these emails must be encoded and formatted before being put in array
    let batchCall = 'users?$filter=mail in (' + emails + ')&$select=givenName,surname,displayName,mail,jobTitle,officeLocation,accountEnabled'
    payload.requests.push({
      'id': id,
      'method': 'GET',
      'url': batchCall
    })
    return payload
  }
}
